import type { CustomFormats } from "react-intl";

export default {
	date: {
		ddmmyyyy: {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
		},
		short: {
			day: "2-digit",
			month: "2-digit",
		},
	},
} as CustomFormats;
